// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1DwIZ0mXtRDS34ShADsFbA {\n  padding: 0.4em;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n}\n", "",{"version":3,"sources":["webpack://src/components/Button/Button.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;AACzB","sourcesContent":[".btn {\n  padding: 0.4em;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btn": "_1DwIZ0mXtRDS34ShADsFbA"
};
export default ___CSS_LOADER_EXPORT___;
